const CompletedSignature = (props) => {
  const left = props.left;
  const bottom = props.bottom;
  const signatureImage = props.signatureImage;
  const type = props.type;
  const text = props.text;

  const style = {
    position: "absolute",
    transform: "translate(0%, 0%)",
    left: `${left}%`,
    bottom: `${bottom}%`,
    width: "100px",
    height: "auto",
  };

  return type === "img" ? (
    <div style={style}>
      <img src={signatureImage} width="auto" height="20" alt=""></img>
    </div>
  ) : (
    <div style={style}>
      <label width="auto" height="20" alt="" class="textFont">
        {text}
      </label>
    </div>
  );
};

export default CompletedSignature;
